module.exports = __webpack_public_path__ + "static/sport/bgi-btn01.b4a5ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/bgi-btn01.png
// module id = 126T
// module chunks = 0